import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";
import i18next from "i18next";
interface IpDetails {
  country_name: string;
  country_code: string;
  location: {
    country_flag: string;
  };
}

interface IpContextType {
  ipData: IpDetails | null;
  loading: boolean;
  error: string | null;
}

const IpContext = createContext<IpContextType | undefined>(undefined);

export const useIpDetails = () => {
  const context = useContext(IpContext);
  if (!context) {
    throw new Error("useIpDetails must be used within an IpProvider");
  }
  return context;
};
const accessKey = process.env.REACT_APP_IPAPI_ACCESS_KEY;

export const IpProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const [ipData, setIpData] = useState<IpDetails | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchIpDetails = async () => {
      try {
        const response = await fetch(
          `https://api.ipapi.com/api/check?access_key=${accessKey}`
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        const germanSpeakingCountries = ["DE", "CH", "AT"];
        if (germanSpeakingCountries.includes(data.country_code ?? "")) {
          i18next.changeLanguage("de");
        } else {
          i18next.changeLanguage("en");
        }
        setIpData(data);
      } catch (err) {
        if (err instanceof Error) {
          setError(err.message);
        } else {
          setError("An unknown error occurred");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchIpDetails();
  }, [accessKey]);

  return (
    <IpContext.Provider value={{ ipData, loading, error }}>
      {children}
    </IpContext.Provider>
  );
};
